import React, { Component, Fragment } from 'react'
import {Media} from 'react-md';
import './Audio.scss'

class Audio extends Component {
  render() {
  	const { AudioUrl } = this.props;   
    return (
      <Fragment>
        <audio src={AudioUrl} preload="auto" controls></audio>
      </Fragment>
    )
  }
}   

export default Audio


// WEBPACK FOOTER //
// ./src/components/Audio/Audio.js